import SectionHeading from "@/components/base/SectionHeading";

const steps = [
  {
    no: "01",
    title: "先看出处",
    desc: "素材来自哪里、什么时候发布，是不是原始版本。这一步决定了后面所有判断的可靠程度。",
    icon: "ri-map-pin-user-line",
  },
  {
    no: "02",
    title: "再拉时间线",
    desc: "把截图、录音、声明按发生顺序排好。单独看一条素材容易被带节奏，串起来才看得清。",
    icon: "ri-timeline-view",
  },
  {
    no: "03",
    title: "对照前后说法",
    desc: "同一方在不同时间点的表述是否一致，是证据合集里最常被验证的部分。",
    icon: "ri-arrow-left-right-line",
  },
  {
    no: "04",
    title: "区分实锤与待核实",
    desc: "没有原始出处的素材只标注为待核实，不当成实锤。看完自己判断，比直接下结论更靠谱。",
    icon: "ri-shield-check-line",
  },
];

export default function GuideSteps() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="How to read"
          title="吃瓜不迷路：四步看证据"
          description="证据合集不是结论合集，它更接近一份可以自己动手核对的材料清单。"
        />

        <ol className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {steps.map((step) => (
            <li
              key={step.no}
              className="relative rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 overflow-hidden"
            >
              <span className="absolute top-4 right-4 font-heading text-3xl md:text-4xl font-black text-background-300/70">
                {step.no}
              </span>
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-300 text-xl">
                <i className={step.icon} />
              </span>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-7 text-foreground-500">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}